import { FC, useContext, useEffect, useState } from "react";
import { Button, CustomLink, Layout } from "../components";
import logo from "../assets/logo.svg";
import { Context } from "..";
import styled from "styled-components";
import $api from "../http";
import config from "../config";
import { Service } from "../types";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

const SixJoin = styled.p`
  font-weight: bold;
  color: red;
`;

const OrderText = styled.p`
  margin: 0;
`;

const OrderPage: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const [joins, setJoins] = useState<number>(0);
  const [orderSum, setOrderSum] = useState<number>(0);
  const [productSum, setProductSum] = useState<number>(0);
  const [serviceSum, setServiceSum] = useState<number>(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!store || !store.order || !store.order.master) return navigate("/default/master");
    setJoins(store.order.joins + 1);

    const isSix = (store.order.joins + 1) % 6 === 0;

    console.log({ isSix });

    store.order.services.forEach((e: Service) => {
      setOrderSum((prev) => (prev += (isSix && e.sale) ? 0 : e.price));
      setServiceSum((prev) => (prev += (isSix && e.sale) ? 0 : e.price));
    });
    store.order.products.forEach((e: Service) => {
      setOrderSum((prev) => (prev += (isSix && e.sale) ? 0 : e.price));
      setProductSum((prev) => (prev += (isSix && e.sale) ? 0 : e.price));
    });

  }, [navigate, store]);

  const sendData = () => {
    let services = "";
    let products = "";
    store.order.services.forEach((e) => services += `${e._id},`);
    store.order.products.forEach((e) => products += `${e._id},`);
    services = services.substring(0, services.length - 1);
    products = products.substring(0, products.length - 1);
    if (store.order.phone === "8") {
      $api
        .post(`${config.API}/client/order`, {
          master_id: store.order.master._id,
          phone: store.order.phone,
          services,
          products,
          isSix: false,
        })
        .then(({ data }) => {
          if (data.status === "error") return alert("Произошла ошибка...");
          navigate("/default");
        });
    } else {
      $api
        .post(`${config.API}/client/order`, {
          master_id: store.order.master._id,
          phone: store.order.phone,
          services,
          products,
          isSix: joins % 6 === 0 && joins !== 0,
        })
        .then(({ data }) => {
          if (data.status === "error") return alert("Произошла ошибка...");
          navigate("/default");
        });
    }
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={160} height={160} />
      <CustomLink to={"/default/phone"}>{"<-"} Изменить</CustomLink>
      {joins % 6 === 0 && joins !== 0 && store.order.phone !== "8" && <SixJoin>Бесплатное посещение! Услуги со скидкой вычтены из чека</SixJoin>}
      <OrderText>
        Клиент: {store.order && store.order.name} {store.order.phone && `(${store.order.phone})`}
      </OrderText>
      <OrderText>Мастер: {store.order.master && store.order.master.name}</OrderText>
      <OrderText>Сумма услуг: {serviceSum}р</OrderText>
      <OrderText>Сумма товаров: {productSum}р</OrderText>
      <OrderText>Итоговая сумма: {orderSum}р</OrderText>
      <OrderText>Посещение №{joins}</OrderText>
      <Button onClick={sendData}>Готово</Button>
    </Layout>
  );
});

export default OrderPage;
